import HttpService from "common/http/httpService";
import ReturnsNullOn404 from "common/http/returnsNullOn404";
import Commodity from "domain/commodity";
import CommodityBalance, { CommodityBalanceType } from "domain/commodityBalance";


class CommodityBalanceService extends HttpService {

    async listForCustomer(customerId: string, excludeEmpty: boolean, customerAccountId?: string): Promise<CommodityBalance[]> {
        const response = await this.getClient().get<CommodityBalance[]>(`/offers/v1/customers/${customerId}/commodity-balances`, {
            params: {
                accountId: customerAccountId,
                excludeEmpty: excludeEmpty
            }
        });
        return response.data;
    }

    @ReturnsNullOn404()
    async getCommodityBalance(filter: CommodityBalanceRequestFilter): Promise<CommodityBalance> {
        const response = await this.getClient().get<CommodityBalance>('/offers/v1/commodity-balances/for-offer', {
            params: filter == null
                ? null
                : {
                    locationId: filter.locationId,
                    commodityId: filter.commodityId,
                    producerId: filter.producerId,
                    producerAccountId: filter.producerAccountId,
                    commodityBalanceType: filter.commodityBalanceType,
                    offerId: filter.offerId
                }
        });
        return response.data;
    }

    @ReturnsNullOn404()
    async listMyCommodityBalances(accountId?: string, excludeEmpty?: boolean): Promise<CommodityBalance[]> {
        const response = await this.getClient().get<CommodityBalance[]>('/offers/v1/commodity-balances', {
            params: {
                accountId: accountId,
                excludeEmpty: excludeEmpty
            }
        });
        return response.data;
    }

    async syncAccountBalances(accountId: string): Promise<any> {
        await this.getClient().post(`/offers/v1/accounts/${accountId}/sync-erp-commodity-balances`, {});
    }

    async getProofOfYieldReport(accountId: string, startDate: string, endDate: string, commodity: Commodity, farmId?: string): Promise<any> {
        return await this.getClient().get(`/offers/v1/agris/accounts/${accountId}/proof-of-yield-report`, {
            responseType: 'blob', params: {
                startDate: startDate,
                endDate: endDate,
                commodityId: commodity.id,
                farmId: farmId
            }
        });
    }
}

export type CommodityBalanceRequestFilter = {
    commodityId: number;
    locationId: string;
    producerId: string;
    producerAccountId: string;
    commodityBalanceType: CommodityBalanceType;
    offerId?: number;
}

const commodityBalanceService = new CommodityBalanceService();
export default commodityBalanceService;
